import script from "./ProMonthlyCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProMonthlyCard.vue?vue&type=script&setup=true&lang=js"

import "./ProMonthlyCard.vue?vue&type=style&index=0&id=2e20379b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e20379b"]])

export default __exports__